import axios from "axios";
import configs from "../../../../Global/config.json";

const IP = configs.SERVER_IP;

const state = {
    metrics: null,
    ListError: null,
};

const getters = {
    getMetrics: state => state.metrics,
    getMetricsError: state => state.ListError,
};

let metricsRequest = 0;

const actions = {
    async fetchMetrics({commit}, data) {
        const requestId = ++metricsRequest;
        try {
            const response = await axios.get(IP + "message/metrics", {params: data || {}});
            if (requestId !== metricsRequest) {
                return;
            }
            // A 500 is returned from the interceptor instead of rejected, so a failed
            // payload must not replace the current report.
            if (!response || response.isAxiosError || !response.data || !response.data.metrics) {
                commit("setMetricsError", response && response.isAxiosError ? response : {
                    response: {data: {message: "Could not load analytics"}},
                });
                return;
            }
            commit("setMetrics", response);
        } catch (error) {
            if (requestId !== metricsRequest) {
                return;
            }
            commit("setMetricsError", error);
        }
    },


};

const mutations = {
    setMetrics: (state, response) => {
        state.metrics = response.data;
        state.ListError = null;
    },

    setMetricsError: (state, error) => {
        state.ListError = error.response ? error.response.data : "Network Error!";
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};

